import APIService from '@/services/APIService';

import User from '@/models/list/User';
import Course from '@/models/list/Course';
import Task from '@/models/list/Task';

export default {

  index(params) {
    return APIService.get('/users', { params, rOptions: { model: User, many: true } });
  },

  show(id, params) {
    return APIService.get(`/users/${id}`, { params, rOptions: { model: User } });
  },

  getSelf(params) {
    return APIService.get('/user', params);
  },

  /**
   * Найти пользователей по ФИО или по названию организации
   * @param params
   * @returns {Promise<AxiosResponse<any>>}
   */
  getUsers(params) {
    return APIService.get('/users', { params });
  },
  /**
   * Получить список преподавателей организации
   * @returns {Promise<AxiosResponse<T>>}
   */
  getOrganizationStaff(params) {
    return APIService.get('/organizations/staff', { params });
  },
  getOrganizationUsers(id, params) {
    return APIService.get(`/organizations/${id}/users`, { params });
  },
  showOrganizationUser(orgId, userId, params) {
    return APIService.get(`/organizations/${orgId}/users/${userId}`, { params });
  },
  saveOrgSettings(id, params) {
    return APIService.put(`/organizations/${id}`, params);
  },
  saveUserSettings(params) {
    return APIService.put('/user', params);
  },
  saveUsersFromDispatcher(data) {
    return APIService.post('/users/from-dispatcher', data);
  },

  /* Related users */

  relatedUsers(params) {
    return APIService.get('/user/related', { params });
  },
  relatedUsersCreate(data) {
    return APIService.post('/user/related', data);
  },
  authRelatedUser(userId) {
    return APIService.post(`/user/related/${userId}/auth`);
  },
  editRelatedUser(userId) {
    return APIService.put(`/user/related/${userId}`);
  },

  /* User education */
  courses(userId, params) {
    return APIService.get(`/users/${userId}/courses`, { params, rOptions: { model: Course, many: true } });
  },
  coursesTasks(userId, courseId, params) {
    return APIService.get(
      `/users/${userId}/courses/${courseId}/tasks`,
      { params, rOptions: { model: Task, many: true } },
    );
  },
  unitsTasks(userId, courseId, unitId, params) {
    return APIService.get(
      `/users/${userId}/courses/${courseId}/course-units/${unitId}/tasks`,
      { params, rOptions: { model: Task, many: true } },
    );
  },
  lessonsTasks(userId, courseId, unitId, lessonId, params) {
    return APIService.get(
      `/users/${userId}/courses/${courseId}/course-units/${unitId}/lessons/${lessonId}/tasks`,
      { params, rOptions: { model: Task, many: true } },
    );
  },
};
